import React from "react";

type IconProps = {
  className?: string;
  stroke?: string;
  fill?: string;
  onClick?: () => void;
};

const HeartOutlineIcon: React.FC<IconProps> = ({ className, onClick }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99984 3C6.69521 2.99967 7.38043 3.16681 7.99755 3.4873C8.36564 3.67847 8.70304 3.92083 9.00022 4.20606C9.77827 3.45968 10.8355 3 11.9998 3C14.393 3 16.3332 4.94014 16.3332 7.33333C16.3332 9.42274 15.1092 11.3329 13.6819 12.7743C12.2481 14.2223 10.4946 15.3145 9.21006 15.7413C9.07358 15.7867 8.9261 15.7867 8.78962 15.7413C7.5051 15.3145 5.75158 14.2223 4.31779 12.7743C2.89048 11.3329 1.6665 9.42274 1.6665 7.33333C1.6665 4.94027 3.60644 3.0002 5.99946 3M7.38303 4.67058C6.95587 4.44874 6.48155 4.33306 6.00021 4.33333L5.99984 4.33333C4.34303 4.33333 2.99984 5.67652 2.99984 7.33333C2.99984 8.91059 3.94253 10.5004 5.26522 11.8362C6.49619 13.0793 7.95774 14.0014 8.99984 14.4007C10.0419 14.0014 11.5035 13.0793 12.7345 11.8362C14.0571 10.5004 14.9998 8.91059 14.9998 7.33333C14.9998 5.67652 13.6566 4.33333 11.9998 4.33333C10.9858 4.33333 10.0887 4.83594 9.54498 5.60841C9.42004 5.7859 9.21652 5.89145 8.99947 5.89133C8.78241 5.89121 8.57901 5.78543 8.45426 5.6078C8.17764 5.2139 7.8102 4.89242 7.38303 4.67058Z"
      />
    </svg>
  );
};

export default HeartOutlineIcon;
